/**
 * Quote subfolder management hook — TS-060 (DEC-COUNCIL-015).
 *
 * Encapsulates project subfolder lazy-creation and 99. QM output folder resolution.
 */

import { useCallback } from 'react';
import {
    generateSubfolderName as generateName,
    ensureQuoteSubfolder as ensureSubfolder,
    ensureQmOutputSubfolder as ensureQmSubfolder,
    EnsureQuoteSubfolderParams,
} from '../services/quote-subfolder-helpers';

export interface UseQuoteSubfoldersOptions {
    formData: any;
    parentFolder: any;
    quoteSubfolder: any;
    setQuoteSubfolder: (subfolder: any) => void;
}

export function useQuoteSubfolders({
    formData,
    parentFolder,
    quoteSubfolder,
    setQuoteSubfolder,
}: UseQuoteSubfoldersOptions) {
    const generateSubfolderName = useCallback((address?: string) => {
        return generateName(formData);
    }, [formData]);

    const ensureQuoteSubfolder = useCallback(async () => {
        return ensureSubfolder({
            quoteSubfolder,
            parentFolder,
            formData,
            setQuoteSubfolder,
        });
    }, [formData, parentFolder, quoteSubfolder, setQuoteSubfolder]);

    const ensureQmOutputSubfolder = useCallback(async () => {
        return ensureQmSubfolder({
            quoteSubfolder,
            parentFolder,
            formData,
            setQuoteSubfolder,
        });
    }, [formData, parentFolder, quoteSubfolder, setQuoteSubfolder]);

    return {
        generateSubfolderName,
        ensureQuoteSubfolder,
        ensureQmOutputSubfolder,
    };
}
